import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import CustomDialogActionsBar from './CustomDialogActionsBar';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';

export default function CustomModal(props) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <Dialog
      closeIcon={props.closeIcon === undefined ? true : props.closeIcon}
      width={props.width === undefined ? '50%' : props.width}
      minWidth={400}
      height={props.height === undefined ? 'auto' : props.height}
      title={props.title}
      onClose={props.onClose}
    >
      {props.body}
      {props.buttons && (
        <DialogActionsBar>
          {<CustomDialogActionsBar buttons={props.buttons} />}
        </DialogActionsBar>
      )}
    </Dialog>
  );
}

CustomModal.propTypes = {
  body: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
    })
  ),
  closeIcon: PropTypes.bool,
  height: PropTypes.any,
  onClose: PropTypes.func,
  scrollable: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.string,
  width: PropTypes.any,
};
